import React from 'react'
import recapIconBnf from '../assets/recapIconBnf.svg'
import recapIconTel from '../assets/recapIconTel.svg'
import recapIconRecharge from '../assets/Img5Sys.svg'
import recapIconMontant from '../assets/recapIconMontant.svg'
import Img3Sys from '../assets/Img3Sys.svg'


const RecapComponent: React.FC<{
  prefix?: string
  Bénéficiaire?: boolean
  phoneNumber?: string
  operateur?: string
  montantEur?: string
  montantTnd?: string
  montantSend?: string
  taxeLocale?: number
  receiveValue?: string
  isChangePrefix?: boolean
  isTaxe?:boolean
  label2 ?: string
  label3 ?: string
  label4 ?: string
  label5 ?: string
  devise?:string
  
  
}> = ({ prefix, phoneNumber, operateur, montantEur, montantTnd,taxeLocale,isTaxe=false,devise,
   isChangePrefix, label2='Opérateur Mobile', label3='Montant à payer' , 
   label4= 'Recharge à envoyer', label5='', montantSend, receiveValue, Bénéficiaire=false }) => {

  return (

  <div className="lg:hidden   w-[380px] xl:w-[250px] font-roboto max-h-max sm:w-full  bg-[#F1F1FF]"> 
  <div className='py-[28px] px-5'>

      <div className="text-[20px] text-[#0A0A0A] font-bold">Synthèse</div>
      {Bénéficiaire &&
      <div className="flex justify-between items-center mt-[25px] text-[15px] ">
        <div className="flex items-center">
          <img src={recapIconBnf} /> <div className="text-[#474747] font-bold pl-3">Bénéficiaire</div>
        </div>
        <div className="text-[#474747] font-bold">
          {phoneNumber &&
          // ((prefix === '+216' && phoneNumber.length > 8) ||
          //   (prefix === '+212' && phoneNumber.length > 9))
          //   ? 'Numéro invalide'
          //   :
             prefix !== undefined && phoneNumber !== undefined
              ? `${prefix} ${phoneNumber}`
              : '--'}
        </div>
      </div>}

      <div className="flex justify-between items-center text-[15px] mt-[25px]">
        <div className="flex items-center">
          <img src={recapIconTel} />
          <div className="text-[#474747]  font-normal pl-3">{label2}</div>
        </div>
        <div className="text-[#474747]  font-normal">
         {operateur ? operateur : '--'}
        </div>
      </div>

      
      <div className="flex justify-between items-center text-[15px] mt-[25px]">
        <div className="flex items-center">
          <img src={recapIconMontant} />
          <div className="text-[#474747]  font-bold pl-3">{label4}</div>
        </div>
        <div className="text-[#474747]  font-bold">
          
          {  montantEur ? prefix !== undefined ? 
           `${montantTnd} ${devise==='EUR' ? '€' : devise}`
            :`${montantSend} ${devise==='EUR' ? '€' : devise}`
          : '__'}

        </div>
      </div>

       

       {isTaxe && 
        <div className="flex justify-between  text-[15px] mt-[25px]">
          <div className="flex items-center">
            <img src={Img3Sys} />
            <div className="text-[#474747]  font-normal pl-3">Montant reçu après taxe locale</div>
          </div>
          <div className="text-[#474747] text-right w-[130px] font-normal">
          {  taxeLocale ? prefix !== undefined ? 
            `${taxeLocale} ${devise==='EUR' ? '€' : devise}`
            :`${montantSend} ${devise==='EUR' ? '€' : devise}`
          : '__'}
          </div>
      </div>}


     
 { label5 && <div className="flex justify-between items-center mt-[25px]">
        <div className="flex items-center">
          <img src={recapIconRecharge} />
          <div className="text-[#474747] text-[15px] font-semibold pl-3">{label5}</div>
        </div>
        <div className="text-[#5754E5] text-[15px] font-semibold">
          {receiveValue ? `${receiveValue} €` : '--'}
        </div>
      </div>}

      <div className="flex justify-between items-center font-bold mt-[25px] border-t border-[#E2E2FB] pt-4">
        <div className="flex items-center">
          <img src={recapIconRecharge} />
          <div className="text-[#735CFE] text-[15px]  pl-3">{label3}</div>
        </div>
        <div className="text-[#735CFE] text-[15px] ">
          {montantEur ? `${montantEur} €` : '--'}
        </div>
      </div>

     

     
  </div>

      <div className='bg-[#D1D1FF] h-[12px]'/>
    </div>
  )
}

export default RecapComponent
